<script setup lang="ts">
const props = withDefaults(defineProps<{
  value: number;
  size?: number;
  strokeWidth?: number;
  backgroundClass?: string;
  circleClass?: string;
}>(), {
  value: 0,
  size: 24,
  strokeWidth: 4,
  backgroundClass: 'stroke-neutral-30',
  circleClass: 'stroke-blue-50',
});

const radius = (props.size - props.strokeWidth) / 2;
const circumference = 2 * Math.PI * radius;
const center = props.size / 2;

const circleStyle = computed(() => {
  const offset = circumference - (props.value / 100) * circumference;
  return {
    strokeDasharray: `${circumference} ${circumference}`,
    strokeDashoffset: offset,
  };
});
</script>

<template>
  <div
    class="relative flex items-center justify-center aspect-1/1"
    :class="`w-[${size}px] h-[${size}px]`"
  >
    <svg
      class="progress-ring"
      :width="size"
      :height="size"
    >
      <circle
        class="fill-transparent"
        :class="backgroundClass"
        :stroke-width="strokeWidth"
        :r="radius"
        :cx="center"
        :cy="center"
      />
      <circle
        class="filled fill-transparent"
        :class="circleClass"
        :stroke-width="strokeWidth"
        :r="radius"
        :cx="center"
        :cy="center"
        :style="circleStyle"
        stroke-linecap="round"
      />
    </svg>

    <slot />
  </div>
</template>

<style scoped lang="scss">
.progress-ring {
  .filled {
    transition: stroke-dashoffset 0.35s;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }
}
</style>